export function getNextNutritionPlanSelectionIndex(
  currentIndex,
  direction,
  itemCount,
) {
  const safeItemCount = Number(itemCount ?? 0);
  if (!Number.isInteger(safeItemCount) || safeItemCount <= 0) {
    return -1;
  }

  const safeCurrentIndex = Number.isInteger(currentIndex) ? currentIndex : -1;
  if (direction === "up") {
    return Math.max(safeCurrentIndex <= 0 ? 0 : safeCurrentIndex - 1, 0);
  }

  return Math.min(
    safeCurrentIndex < 0 ? 0 : safeCurrentIndex + 1,
    safeItemCount - 1,
  );
}

export function shouldRevealNutritionSelectionRow(
  selectedIndex,
  selectionInputSource,
) {
  return Number.isInteger(selectedIndex) && selectedIndex >= 0
    ? selectionInputSource === "keyboard"
    : false;
}
